export default __webpack_public_path__ + "static/media/portada_DanielaViloria_ENG.78e69dc6.jpg";